import React, { createContext, useCallback, useMemo, useState } from "react";

export const CompliancePanelContext = createContext(null);

export const CompliancePanelProvider = ({ children }) => {
    const [resultadosCache, setResultadosCache] = useState({});
    const [detalleCache, setDetalleCache] = useState({});
    const [transaccionalCache, setTransaccionalCache] = useState({});

    const guardarResultados = useCallback((key, value) => {
        setResultadosCache((prev) => ({
            ...prev,
            [key]: value,
        }));
    }, []);

    const guardarDetalle = useCallback((key, value) => {
        setDetalleCache((prev) => ({
            ...prev,
            [key]: value,
        }));
    }, []);

    const guardarTransaccional = useCallback((key, value) => {
        setTransaccionalCache((prev) => ({
            ...prev,
            [key]: value,
        }));
    }, []);

    const value = useMemo(() => ({
        resultadosCache,
        detalleCache,
        transaccionalCache,
        guardarResultados,
        guardarDetalle,
        guardarTransaccional,
    }), [detalleCache, guardarDetalle, guardarResultados, guardarTransaccional, resultadosCache, transaccionalCache]);

    return (
        <CompliancePanelContext.Provider value={value}>
            {children}
        </CompliancePanelContext.Provider>
    );
};
